import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TextSelectDirective } from './text-select.directive';

@NgModule({
    imports: [CommonModule],
    exports: [TextSelectDirective],
    declarations: [TextSelectDirective]
})
export class TextSelectModule { }
